import styled from 'styled-components';

export const H2 = styled.h2`
  font-size: ${({ theme }) => theme.text.fontSize.xl};
  font-weight: ${({ theme }) => theme.text.fontWeight.medium};
  color: ${({ theme }) => theme.colors.primary};
  opacity: ${({ theme }) => theme.emphasis.high};
  font-family: 'ProductSansBold';
`;
